module.exports = __webpack_public_path__ + "img/loading.cd9ca0e6.gif";